import React from 'react';
import Section from './body/Section';
import Main from './body/Main';
import Servicios from './body/Servicios';
import Contacto from './body/Contacto';
import Direccion from './body/Direccion.jsx';


const Inicio = () => {
  return (
    <div>
    <Section/>
    <Main/>
    <Servicios/>
    <Contacto/>
    <Direccion/>
    </div>
  );
};

export default Inicio;